'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

/*

    Given project data & nodes rects, returns a rendered graph

*/

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pureGraph = require('pure-graph');

var _StaticNodeView = require('./StaticNodeView');

var _StaticNodeView2 = _interopRequireDefault(_StaticNodeView);

var _StaticEdgeView = require('./StaticEdgeView');

var _StaticEdgeView2 = _interopRequireDefault(_StaticEdgeView);

var _computational = require('./utils/computational');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// rendering nodes

var renderNode = function renderNode(_ref) {
  var id = _ref.id;
  var x = _ref.x;
  var y = _ref.y;
  var width = _ref.width;
  var height = _ref.height;
  var color = _ref.color;
  var caption = _ref.caption;

  var tx = Math.round(x);
  var ty = Math.round(y);

  return _react2.default.createElement(
    'g',
    { key: id, transform: 'translate(' + tx + ', ' + ty + ')' },
    _react2.default.createElement(_StaticNodeView2.default, {
      id: id, width: width, height: height, color: color, caption: caption
    })
  );
};

var renderNodes = function renderNodes(nodes, rects) {
  return nodes.map(function (node) {
    var id = node.id;
    var data = node.data;
    var _rects$id = rects[id];
    var width = _rects$id.width;
    var height = _rects$id.height;


    return renderNode(_extends({}, data, { id: id, width: width, height: height }));
  });
};

// rendering edges

var renderEdge = function renderEdge(_ref2) {
  var id = _ref2.id;
  var color = _ref2.color;
  var startX = _ref2.startX;
  var startY = _ref2.startY;
  var endX = _ref2.endX;
  var endY = _ref2.endY;
  var startDirX = _ref2.startDirX;
  var startDirY = _ref2.startDirY;
  var endDirX = _ref2.endDirX;
  var endDirY = _ref2.endDirY;

  return _react2.default.createElement(_StaticEdgeView2.default, _extends({
    key: id,
    color: color
  }, { startX: startX, startY: startY, endX: endX, endY: endY, startDirX: startDirX, startDirY: startDirY, endDirX: endDirX, endDirY: endDirY }));
};

var renderEdges = function renderEdges(edges, nodesData, nodesRects) {
  return edges.map(function (edge) {
    var id = edge.id;
    var from = edge.from;
    var to = edge.to;
    var _nodesData$from = nodesData[from];
    var fromX = _nodesData$from.x;
    var fromY = _nodesData$from.y;
    var _nodesData$to = nodesData[to];
    var toX = _nodesData$to.x;
    var toY = _nodesData$to.y;
    var _nodesRects$from = nodesRects[from];
    var fromWidth = _nodesRects$from.width;
    var fromHeight = _nodesRects$from.height;
    var _nodesRects$to = nodesRects[to];
    var toWidth = _nodesRects$to.width;
    var toHeight = _nodesRects$to.height;

    var _getEdgeCoordinates = (0, _computational.getEdgeCoordinates)({ fromX: fromX, fromY: fromY, toX: toX, toY: toY, fromWidth: fromWidth, fromHeight: fromHeight, toWidth: toWidth, toHeight: toHeight });

    var startX = _getEdgeCoordinates.startX;
    var startY = _getEdgeCoordinates.startY;
    var endX = _getEdgeCoordinates.endX;
    var endY = _getEdgeCoordinates.endY;
    var startDirX = _getEdgeCoordinates.startDirX;
    var startDirY = _getEdgeCoordinates.startDirY;
    var endDirX = _getEdgeCoordinates.endDirX;
    var endDirY = _getEdgeCoordinates.endDirY;
    var edgeColor = nodesData[to].color;


    return renderEdge({
      id: id, color: edgeColor,
      startX: startX, startY: startY,
      endX: endX, endY: endY,
      startDirX: startDirX, startDirY: startDirY,
      endDirX: endDirX, endDirY: endDirY
    });
  });
};

var StaticProjectView = (_temp = _class = function (_Component) {
  _inherits(StaticProjectView, _Component);

  function StaticProjectView() {
    _classCallCheck(this, StaticProjectView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(StaticProjectView).apply(this, arguments));
  }

  _createClass(StaticProjectView, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var graph = _props.graph;
      var nodesData = _props.nodesData;
      var nodesRects = _props.nodesRects;
      var viewWidth = _props.viewWidth;
      var viewHeight = _props.viewHeight;
      var viewX = _props.viewX;
      var viewY = _props.viewY;


      var nodes = (0, _pureGraph.getNodes)(graph);
      var mappedNodesData = nodes.map(function (id) {
        return { id: id, data: nodesData[id] };
      });

      var edges = (0, _pureGraph.getEdges)(graph);

      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: viewWidth,
          height: viewHeight
        },
        _react2.default.createElement(
          'g',
          { transform: 'translate(' + viewX + ', ' + viewY + ')' },
          renderEdges(edges, nodesData, nodesRects),
          renderNodes(mappedNodesData, nodesRects)
        )
      );
    }
  }]);

  return StaticProjectView;
}(_react.Component), _class.propTypes = {
  graph: _react.PropTypes.object.isRequired,
  nodesData: _react.PropTypes.object.isRequired,
  nodesRects: _react.PropTypes.object.isRequired,

  viewWidth: _react.PropTypes.number.isRequired,
  viewHeight: _react.PropTypes.number.isRequired,
  viewX: _react.PropTypes.number.isRequired,
  viewY: _react.PropTypes.number.isRequired
}, _temp);
exports.default = StaticProjectView;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/StaticProjectView/StaticProjectView.js
// module id = 610
// module chunks = 1